
import {EnvType, GlobalConfig} from "../../common/appConfig"

const API_Clinic = {
	getSomosOfficeLocationList: 'iClinic/GetSomosOfficeLocationList',
	getCovid19VaccineRecord: 'iClinic/GetCovid19VaccineRecord',
	getSomosAppointment: 'iClinic/GetSomosAppointment',
	cancelSomosAppointment: 'iClinic/CancelSomosAppointment',
}

const API_Appointment = {
	canAddAppointment: 'Appointment/CanAddAppointment',
	addAppointmentAccountID: 'Appointment/AddAppointment',
	loadMasterDBPatientInfo: 'Appointment/LoadMasterDBPatientInfo',
	getClinicIDAndPatientID: 'Appointment/GetClinicIDAndPatientID',
	getDoctorLink: 'Appointment/GetDoctorLink'
}

const API_Doctor = {
	getAvailableDoctors: 'Doctor/GetAvailableDoctors',
	searchDoctors: 'Doctor/SearchDoctors',
	filterDoctors: 'Doctor/FilterDoctors',
	nextPage: 'Doctor/DoctorsNextPage',
	getOfficeLocations: 'Doctor/GetOfficeLocations',
    getAppointmentAvailableTimeSlots: 'Doctor/GetAppointmentAvailableTimeSlots',
	favoriteDoctor: 'Doctor/FavoriteDoctor',
	cancelFavoriteDoctor: 'Doctor/CancelFavoriteDoctor',
	getFavoriteDoctors: 'Doctor/GetFavoriteDoctors',
	addFavor: 'Doctor/FavoriteDoctor',
	cancelFavor: 'Doctor/CancelFavoriteDoctor',
	checkFavorStatus: 'Doctor/IsFavorited',
	getTrendingKeywords: 'Doctor/GetTrendingKeywords',
	getAvailableKeywords: 'Doctor/GetAvailableKeywords',
	getOneDoctorAES: 'Doctor/GetOneDoctorAES',
	getAppointmentAvailableDateList: 'Doctor/GetAppointmentAvailableDateList',
	initFavoriteDoctors: 'Doctor/InitFavoriteDoctors'
}

const API_MPatient = {
	loadMasterDBPatientInfoByAccountID: 'MPatient/LoadMasterDBPatientInfoByAccountID',
	getClinicIDAndPatientIDByAccountID: 'MPatient/GetClinicIDAndPatientIDByAccountID',
	submitPatientFeedback: 'MPatient/SubmitPatientFeedback',
	addManualInputSettingNew: 'MPatient/AddManualInputSettingNew',
	getManualInputSettingNew: 'MPatient/GetManualInputSettingNew',
};

const API_LogIn = {
	login: 'Login/Login',
	IDmeWebLogin: 'Login/IDmeWebLogin',
	IDmeVerifiedUser: 'Login/GetIDmeVerifiedUser'
};

const API_Record = {
	showVaccineHisByAccountIDByPage: 'Record/ShowVaccineHisByAccountIDByPage'
};

const API_Monitor = {
	getHistoryVitalSignByPageAndAccountID: 'Monitor/GetHistoryVitalSignByPageAndAccountID',
	getLatestVitalSignItemValues: 'Monitor/GetLatestVitalSignItemValues',
	getVitalSignItemValuesByDate: 'Monitor/GetVitalSignItemValuesByDate',
	addVitalSignItemValue: 'Monitor/AddVitalSignItemValue',
	getVitalSignRange: 'Monitor/GetVitalSignRange',
};

const GetAPIHost = () => {
	if (GlobalConfig.envType === EnvType.dev) {
		return 'https://api-app-d.mdland.com'
	}else if (GlobalConfig.envType === EnvType.uat) {
		return 'https://api-app.iclinichealth.net'
	}else {
		return 'https://api-app-p.mdland.com'
	}
}

const GetAPIBaseURL = (apiService) => {
	const host = window.location.href.includes("localhost") ? "" : GetAPIHost();
	return host + apiService
}

const API_Service = {
	ezHealth: '/ezhealth/',
	appointment: '/appointment/',
};

export {
	API_Clinic,
	API_Appointment,
	API_LogIn,
	API_MPatient,
	API_Doctor,
	GetAPIHost,
	GetAPIBaseURL,
	API_Service,
	API_Record,
	API_Monitor,
}
